import { useState, useMemo } from 'react'
import { useParams } from 'react-router-dom'
import AdvisingDiagnostic from '../../components/home/AdvisingDiagnostic'
import AcademicPathwayViewer from '../../components/home/AcademicPathwayViewer'
import JobMarketInsights from '../../components/home/JobMarketInsights'
import HomeStats from '../../components/home/HomeStats/HomeStats'
import { Sparkles, GraduationCap, Briefcase } from 'lucide-react'
import './styles.scss'

const THEME_CONFIG = {
  memphis: {
    code: 'UOM',
    name: 'University of Memphis',
    primary: '#00498F',
    primaryRgb: '0, 73, 143',
    primaryLight: '#193059'
  },
  uom: {
    code: 'UOM',
    name: 'University of Memphis',
    primary: '#00498F',
    primaryRgb: '0, 73, 143',
    primaryLight: '#193059'
  },
  tsu: {
    code: 'TSU',
    name: 'Tennessee State University',
    primary: '#0033A0', // Example TSU Blue
    primaryRgb: '0, 51, 160',
    primaryLight: '#00205B'
  },
  // Add more universities here...
};

const DEFAULT_THEME = {
  code: 'UNKNOWN',
  name: 'Partner Institution',
  primary: '#ed7534', // Linqra Orange
  primaryRgb: '237, 117, 52',
  primaryLight: '#d65d1f'
};

export default function EmbedHome() {
  const { instCode } = useParams()
  const [activeTab, setActiveTab] = useState('diagnostic') // 'diagnostic', 'pathway', or 'market'

  const themeConfig = useMemo(() => {
    const key = (instCode || '').toLowerCase();
    return THEME_CONFIG[key] || DEFAULT_THEME;
  }, [instCode]);

  const themeVariables = {
    '--embed-primary': themeConfig.primary,
    '--embed-primary-rgb': themeConfig.primaryRgb,
    '--embed-primary-light': themeConfig.primaryLight
  };

  const institution = themeConfig.code;
  const institutionName = themeConfig.name;
  const availableInstitutions = [{ shortName: institution, fullName: institutionName }];

  return (
    <div className="theme-dynamic-embed" style={themeVariables}>
      <div className="embed-container">
        {/* We keep the diagnostic section without the hero marketing content */}
        <section id="diagnostic-assistant" className="embed-diagnostic-section">
          <div className="embed-title-container">
            <h2>{institutionName} AI Advising Assistant</h2>
            <p>Powered by PolyTechnicApp Intelligence</p>
          </div>

          <HomeStats
            institution={institution}
            setInstitution={() => {}} // Disabled switching in embed mode
            institutionName={institutionName}
            availableInstitutions={availableInstitutions}
          />

          <div className="home-tabs-container">
            <div className="tabs-switcher-glass">
              <button
                className={`tab-switch-btn ${activeTab === 'diagnostic' ? 'active' : ''}`}
                onClick={() => setActiveTab('diagnostic')}
              >
                <Sparkles size={18} />
                <span>AI Advisor</span>
              </button>
              <button
                className={`tab-switch-btn ${activeTab === 'pathway' ? 'active' : ''}`}
                onClick={() => setActiveTab('pathway')}
              >
                <GraduationCap size={18} />
                <span>Pathway Explorer</span>
              </button>
              <button
                className={`tab-switch-btn ${activeTab === 'market' ? 'active' : ''}`}
                onClick={() => setActiveTab('market')}
              >
                <Briefcase size={18} />
                <span>Job & Salaries</span>
              </button>
            </div>
          </div>

          <div className="tab-content-area">
            {activeTab === 'diagnostic' && (
              <AdvisingDiagnostic
                institution={institution}
                displayName={institutionName}
                pdfColorRgb={themeConfig.primaryRgb}
              />
            )}
            {activeTab === 'pathway' && (
              <AcademicPathwayViewer
                institution={institution}
                displayName={institutionName}
              />
            )}
            {activeTab === 'market' && (
              <JobMarketInsights
                institution={institution}
                displayName={institutionName}
              />
            )}
          </div>
        </section>
      </div>
    </div>
  )
}
